<!-- VCN系统列表页面 -->
<template>
  <div class="vcnSystmList section-main__warp1">
    <ioc-table
      :data="deviceData"
      :option="deviceOption"
      :page="devicePage"
      @current-change="changePage"
      @size-change="changeSize"
    >
      <div>
        <template slot="menuLeft">
          <el-button
            type="text"
            :disabled="deviceData.length >= 0"
            class="iss-operation-button m0"
            icon="iconfont icon-xinzeng"
            v-auth="'/deviceaccess/index:addDevice'"
            @click="addDeviceSystem"
          >
            {{ $t("deviceAccess.button.addsystem") }}
          </el-button>
        </template>
      </div>
      <template slot="menu" slot-scope="scope">
        <!-- <el-tooltip class="item"
                    effect="dark"
                    :content="$t('deviceAccess.button.edit')"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     @click="modSysDel(scope.row)"
                     :disabled="true"
                     icon="iconfont icon-xiugai"
                     v-auth="'/deviceaccess/index:updateDevice'"></el-button>
        </el-tooltip> -->
        <!-- 设备列表 -->
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('deviceAccess.button.devlist')"
          placement="top"
          popper-class="tooltip-draw"
          v-if="
            scope.row.systemId == '200000024' ||
            scope.row.systemId == '200000011' ||
            scope.row.systemId == '200000008' ||
            scope.row.systemId == '200000014' ||
            scope.row.systemId == '200000017' ||
            scope.row.systemId == '200000015' ||
            scope.row.systemId == '200000023' ||
            scope.row.systemId == '200000024'
          "
        >
          <el-button
            type="text"
            @click="goDevList(scope.row)"
            icon="iconfont icon-task-all"
          ></el-button>
        </el-tooltip>
        <!-- 刷新列表 -->
        <el-tooltip
          class="item"
          effect="dark"
          v-auth="'/deviceaccess/index:query'"
          :content="$t('deviceAccess.button.update')"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            @click="refreshStatus(scope.row, scope.index)"
            class="el-icon-refresh"
          ></el-button>
        </el-tooltip>
        <!-- <el-tooltip class="item"
                    effect="dark"
                    :content="$t('deviceAccess.button.eventconf')"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     @click="eventCon(scope.row,scope.index)"
                     icon="iconfont icon-shezhi"
                     v-auth="'/deviceaccess/index:updateDevice'"></el-button>
        </el-tooltip> -->
        <!-- <el-tooltip class="item"
                    effect="dark"
                    :content="$t('deviceAccess.button.uninstall')"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     @click="delSystm(scope.row,scope.index)"
                     icon="iconfont icon-shanchu"
                     v-auth="'/deviceaccess/index:deleteDevice'"></el-button>
        </el-tooltip> -->
      </template>
    </ioc-table>

    <el-dialog
      :title="$t('deviceAccess.title.uninstall')"
      width="20%"
      v-dialogDrag
      :visible.sync="dialogVisible"
    >
      <span>{{ $t("deviceAccess.message.uninstall") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dlgYes">{{
          $t("deviceAccess.button.confirm")
        }}</el-button>
        <el-button type="info" @click="dlgNo">{{
          $t("deviceAccess.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../../api";
import utils from "@src/common/utils";
import { Dic } from "$utils";

export default {
  props: ["sel"],
  data() {
    return {
      // 删除按钮获取数据
      delRow: {},
      // 控制dialog显隐
      dialogVisible: false,
      // 系统列表的类型
      deviceType: this.sel,
      deviceOption: {
        addBtn: false,
        emptyText: this.$t("deviceAccess.message.nodata"),
        refreshBtn: false,
        columnBtn: false,
        maxHeight: "100%",
        stripe: true,
        page: true,
        menuAlign: "center",
        delBtn: false,
        editBtn: false,
        align: "left",
        column: [
          {
            label: this.$t("deviceAccess.label.factory"),
            prop: "factoryName",
            labelWidth: "88",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.systemname"),
            prop: "systemName",
            labelWidth: "88",
            overHidden: true,
          },
          {
            label: "所属园区",
            prop: "parkName",
            labelWidth: "88",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.version"),
            prop: "platVersion",
            labelWidth: "88",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.systemstatus"),
            prop: "status",
            labelWidth: "88",
            overHidden: true,
            formatter: function (row, value) {
              return Dic.findByValue("SENU015", value);
            },
          },
          {
            label: this.$t("deviceAccess.label.connection"),
            prop: "connectionMode",
            labelWidth: "88",
            overHidden: true,
          },
        ],
      },
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceData: [],
    };
  },
  created() {
    // 请求系统列表数据
    this.getDdeviceList();
  },
  methods: {
    // 新增设备系统按钮
    addDeviceSystem() {
      this.$router.push({
        path: "/deviceaccess/addvcnsystem",
        name: "addvcnsystem",
        query: {
          deviceType: this.deviceType,
        },
      });
    },
    // 查看系统详情按钮
    modSysDel(row) {
      this.$router.push({
        path: "/deviceaccess/systemdetail",
        name: "systemdetail",
        query: {
          systemId: row.systemId,
        },
      });
    },
    // 设备列表按钮
    goDevList(row) {
      console.log(row, "=====");
      const query = {
        systemId: row.systemId,
        systemName: row.systemName,
        platID: row.platId,
        factoryId: row.factoryId,
        deviceType: row.deviceType,
      };
      if (row.systemId === 200000005) {
        this.$router.push({
          path: "/deviceaccess/NvrDeviceMg",
          name: "NvrDeviceMg",
          query: query,
        });
      } else if (row.systemId === 200000019) {
        // 消防
        this.$router.push({
          path: "/deviceaccess/fireDeviceMg",
          name: "fireDeviceMg",
          query: query,
        });
      } else if (row.systemId === 200000010) {
        this.$router.push({
          path: "/deviceaccess/fireTruckMg",
          name: "fireTruckMg",
          query: query,
        });
      } else if (row.systemId === 200000011) {
        // 一键求救
        this.$router.push({
          path: "/deviceaccess/touchHelp",
          name: "touchHelp",
          query: query,
        });
      } else if (row.systemId === 200000012) {
        // 电气火灾
        this.$router.push({
          path: "/deviceaccess/electricFireMg",
          name: "electricFireMg",
          query: query,
        });
      } else if (row.systemId === 200000013) {
        this.$router.push({
          path: "/deviceaccess/gasConfig",
          name: "gasConfig",
          query: query,
        });
      } else if (row.systemId === 200000017) {
        // 道闸
        this.$router.push({
          path: "/deviceaccess/gateWay",
          name: "gateWay",
          query: query,
        });
      } else if (row.systemId === 200000024) {
        //IOT插件
        this.$router.push({
          path: "/deviceaccess/IOT",
          name: "IOT",
          query: query,
        });
      } else {
        this.$router.push({
          path: "/deviceaccess/vcndeviceList",
          name: "vcndevicelist",
          query: query,
        });
      }
    },
    // 事件配置按钮
    eventCon(row) {
      this.$router.push({
        path: "/deviceaccess/eventconfignew",
        name: "eventconfignew",
        query: {
          factoryId: row.factoryId,
          systemId: row.systemId,
          systemName: row.systemName,
          deviceType: this.deviceType,
        },
      });
    },

    refreshStatus(row) {
      this.$log.info("设备--rowInfo", row);
      const params = {
        deviceType: row.deviceType,
        factoryId: row.factoryId,
        platId: row.platId,
        systemId: row.systemId,
      };
      this.$fetch(api.device.queryPlatSystemStatus, params).then((res) => {
        if (res.success) {
          row.status = res.returnObj.status;
          this.$message.success(res.msgContent);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 删除系统按钮
    delSystm(row) {
      this.delRow = row;
      this.dialogVisible = true;
    },
    // 确认删除
    dlgYes() {
      this.dialogVisible = false;
      const params = {
        systemId: this.delRow.systemId,
        platId: this.delRow.platId,
      };
      this.$fetch(api.device.deleteSystemInfo, params).then((res) => {
        if (res.success == true) {
          this.getDdeviceList();
          this.$message.success(res.msgContent);
        } else if (res.success == false) {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 取消删除
    dlgNo() {
      this.dialogVisible = false;
    },
    getDdeviceList() {
      const params = {
        // deviceType: this.deviceType,
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.device.queryPlatSystemList, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        this.deviceData = res.returnObj.list;
        this.deviceData.map((item, index) => {
          if (item.connectionMode == 1) {
            this.deviceData[index].connectionMode = this.$t(
              "deviceAccess.label.platform"
            );
          } else if (item.connectionMode == 2) {
            this.deviceData[index].connectionMode = this.$t(
              "deviceAccess.label.straightthrough"
            );
          }
        });
        this.devicePage.total = res.returnObj.total;
        this.devicePage.currentPage = res.returnObj.pageNum;
      });
    },

    // 前往输入的页数
    changePage(val) {
      this.devicePage.currentPage = val;
      this.getDdeviceList();
    },
    changeSize(val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      this.getDdeviceList();
    },
  },
};
</script>
<style lang="scss" scoped>
.vcnSystmList {
  width: 100%;
  height: 100%;
}
</style>
